"use strict";
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceServerInUrl = void 0;
function replaceServerInUrl(url, server) {
    const parsedUrl = new URL(url);
    const parsedServerUrl = new URL(server);
    // Replace protocol and host
    parsedUrl.protocol = parsedServerUrl.protocol;
    parsedUrl.host = parsedServerUrl.host;
    // Replace the port if the new server URL specifies one, otherwise clear it.
    parsedUrl.port = parsedServerUrl.port || "";
    return parsedUrl.toString();
}
exports.replaceServerInUrl = replaceServerInUrl;
